<template>
  <div class="gk-badge" :class="['gk-badge--' + type, 'gk-badge--' + type + '__' + variant, {'icon-only': iconOnly}]">
    <template v-if="!iconOnly">
      <span v-if="iconRight">{{ text }}</span>
      <font-awesome-icon v-if="icon" :icon="icon" />
      <slot name="icon" />
      <span v-if="!iconRight">{{ text }}</span>
      <span v-if="extra" class="extra">{{ extra }}</span>
    </template>
    <template v-if="iconOnly">
      <font-awesome-icon v-if="icon" :icon="icon" />
    </template>
  </div>
</template>

<script>
export default {
  name: 'GkBadge',
  props: {
    type: {
      type: String,
      default: 'premium'
    },
    variant: {
      type: String,
      default: 'base'
    },
    text: {
      type: String,
      default: '',
    },
    extra: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    iconRight: {
      type: Boolean,
      default: false    
    },
    iconOnly: {
      type: Boolean,
      default: false    
    },
  },
  data () {
    return {
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.gk-badge {
  width: auto !important;
  border-radius: $radiusXl;
  padding: 0.25rem 0.5rem;
  display: inline-block;
  .extra {
    position: relative;
    padding-left: 10px;
    &:before {
      content: "";
      left: 4px;
      position: absolute;
      width: 1px;
      height: 100%;
      background: currentColor;
      top: 0;
      opacity: 0.5;
    }
  }
  &.icon-only {
    aspect-ratio: 1;
    width: auto !important;
    height: auto !important;
    padding: 0.25em !important;
    font-size: 14px;
    .svg-inline--fa {
    }
  }
}
</style>
